import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { lazy, Suspense, useContext, useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loader from '../Loader/Loader';

import ContactInformation from '../LeadGeneration/StepOne/ContactInformation';

import ProductCDIRA from '../LeadGeneration/ProductQuestion/ProductCDIRA';

import { isWebComponentFlow } from '../commonCode';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import LoginPageInternal from '../../WebComponents/internalTesting/LoginPageInternal';
import DummyPageInternal from '../../WebComponents/internalTesting/DummyPageInternal';

const Overlay = lazy(() => import('../Overlay/Overlay'));
const FormHandler = lazy(() => import('../LeadGeneration/FormHandler'));
function Routing() {
  const history = useHistory();
  const { wcData, setWcData, setCurrentPage } = useContext(LeadGenerationContext);
  const baseContext = isWebComponentFlow();

  useEffect(() => {
    const onOffers = (e) => {
      setWcData(e?.detail);
      history.push('/test-login-inline');
    };

    const hideHeader = (e) => {
      setCurrentPage('dummywc');
    };
    window.addEventListener('offers-product-wc', onOffers, { passive: true });
    window.addEventListener('hide-header', hideHeader, { passive: true });
    return () => {
      window.removeEventListener('offers-product-wc', onOffers);
      window.removeEventListener('hide-header', hideHeader);
    };
  }, []);

  console.log('wcData in Routing', wcData, { baseContext });
  return (
    <div style={{ height: '100%' }}>
      <Suspense
        fallback={
          <div className="loader-style">
            <Loader />{' '}
          </div>
        }
      >
        <Switch>
          <Route exact path="/:region/:lang/:journeyType/:product/:page/" component={FormHandler} />
          <Route
            exact
            path="/:region/:lang/express/:journeyType/:product/:page/"
            component={FormHandler}
          />
          <Route exact path="/:region/:lang/:journeyType/:page/" component={FormHandler} />
          <Route exact path="/:region/:lang/:product/:page/" component={FormHandler} />
          <Route exact path="/:lang/:journeyType/:page/" component={FormHandler} />
          <Route exact path="/:lang/:page/" component={FormHandler} />
          <Route exact path="/" component={Overlay} />
          <Route exact path="/bundle" component={ProductCDIRA} />
          {/* <Route exact path="/loader" component={LoaderCarousel} /> */}
          <Route exact path="/cd-success" component={ContactInformation} />
          <Route
            exact
            path="/test-login-inline"
            render={(routeProps) => <LoginPageInternal {...routeProps} wcData={wcData} />}
          />

          <Route
            exact
            path="/test-dummy-inline"
            render={(routeProps) => <DummyPageInternal {...routeProps} />}
          />
        </Switch>
      </Suspense>
    </div>
  );
}

export default Routing;
